export default (payload = [], itemKey = '', sourceKey = 'profile') => payload
  .filter(item => (item.datumType === itemKey && item.source.toLowerCase() === sourceKey))
  .map(filtered => ({
    value: JSON.parse(filtered.dataItem),
    id: filtered.id,
  }));
